import React, { useEffect } from 'react'
import Header from '../../../headerone/Main'
import Bredcom from '../../../Bredcom/Main'
import DisasterResponseRecoveryDetails from '../../subdepartmentdetails/DisasterResponseRecovery'


function DisasterResponseRecovery() {

  useEffect(() => {
    document.getElementById("title").innerHTML="Disaster Response and Recovery Operations || Public Safety";
  }, [])


  return (
    <>
        {/* Header is now rendered at app level in routes/index.js to prevent remounting on navigation */}

        <div className="page-wrapper">
        <Bredcom 
            subtitle="Public Safety"
            title="Disaster Response Recovery"
            subtitledown="Department of Public Safety"
           />
            <DisasterResponseRecoveryDetails/>
        </div>
    </>
  )
}

export default DisasterResponseRecovery